import { css } from '@emotion/core'

export const styles = {
  container: css`
    width: 100vw;
    height: 70px;

    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: stretch;

    background: rgba(255, 255, 255, 0.97);
    color: #777777;
    z-index: 100;
  `,

  section: css`
    display: flex;
    align-items: stretch;
  `,

  item: css`
    display: flex;
    align-items: center;

    padding: 0 1.5vw;
    font-size: 14px;
    font-weight: 600;

    cursor: pointer;
    transition: 300ms;

    &:hover {
      color: black;
      transition: 300ms;
    }
  `,

  title: {
    container: css`
      font-size: 24px;
      cursor: pointer;

      & * {
        font-family: 'Comfortaa', cursive !important;
      }

      margin: 0 0 5px 0;
    `,

    name: css`
      color: #22303d;
    `,

    ext: css`
      color: #3a89c4;
    `,
  },
}
